import React from 'react';
import Icon from '../../../components/AppIcon';

const OverallAnalytics = ({ metrics }) => {
  const metricCards = [
    {
      title: 'Overall Completion Rate',
      value: `${metrics?.completionRate}%`,
      trend: metrics?.completionTrend,
      icon: 'TrendingUp',
      color: 'text-blue-500',
      bgColor: 'bg-blue-500/10'
    },
    {
      title: 'Mandatory Compliance',
      value: `${metrics?.mandatoryCompliance}%`,
      trend: metrics?.mandatoryTrend,
      icon: 'Shield',
      color: 'text-green-500',
      bgColor: 'bg-green-500/10'
    },
    {
      title: 'Overdue Training',
      value: metrics?.overdueTraining,
      trend: metrics?.overdueTrend,
      icon: 'AlertTriangle',
      color: 'text-red-500',
      bgColor: 'bg-red-500/10',
      invertTrend: true
    },
    {
      title: 'Certifications Expiring',
      value: metrics?.certificationsExpiring,
      trend: metrics?.certificationsTrend,
      icon: 'Calendar',
      color: 'text-orange-500',
      bgColor: 'bg-orange-500/10'
    },
    {
      title: 'Avg Assessment Score',
      value: `${metrics?.averageAssessmentScore}%`,
      trend: metrics?.assessmentTrend,
      icon: 'Award',
      color: 'text-purple-500',
      bgColor: 'bg-purple-500/10'
    },
    {
      title: 'Total Employees',
      value: metrics?.totalEmployees,
      trend: metrics?.employeesTrend,
      icon: 'Users',
      color: 'text-gray-500',
      bgColor: 'bg-gray-500/10'
    }
  ];

  return (
    <div className="mb-6">
      <h2 className="text-2xl font-semibold text-foreground mb-4">Overall Analytics</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {metricCards?.map((card, index) => (
          <div key={index} className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-shadow">
            <div className="flex items-start justify-between mb-4">
              <div className={`w-12 h-12 rounded-lg ${card?.bgColor} flex items-center justify-center`}>
                <Icon name={card?.icon} size={24} className={card?.color} />
              </div>
              {card?.trend !== 0 && (
                <div className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${
                  (card?.invertTrend ? card?.trend < 0 : card?.trend > 0)
                    ? 'bg-success/10 text-success' :'bg-destructive/10 text-destructive'
                }`}>
                  <Icon
                    name={(card?.invertTrend ? card?.trend < 0 : card?.trend > 0) ? 'TrendingUp' : 'TrendingDown'}
                    size={12}
                  />
                  <span>{Math.abs(card?.trend)}%</span>
                </div>
              )}
            </div>
            <div>
              <p className="text-sm text-muted-foreground mb-1">{card?.title}</p>
              <p className="text-2xl font-bold text-foreground">{card?.value}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OverallAnalytics;